import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import download from 'downloadjs';

import { API_ROOT } from '../../../api/constants';

import { ContentBlock } from '../../pages/components';
import Button from '../../../ui/button/Button';
import { Localize } from '../../../locale/localization';

class ScoreAdminBlock extends Component {
  onPrintScoresClick = () => {
    const token = localStorage.getItem('cmore-sisapiiri-token');
    const url = `${API_ROOT}api/transaction/export/score`;
    const init = {
      method: 'POST',
      headers: new Headers({
        'authtoken': `${token}`,
      }),
    };

    fetch(url, init).then(function(resp) {
      return resp.blob();
    }).then(function(blob) {
      download(blob);
    });
  }

  renderHeaderActions = () => {
    return <Button onClick={this.onPrintScoresClick}>Tulosta pisteet</Button>;
  }

  render() {
    return (
      <ContentBlock
        title={Localize("scores")}
        renderActions={this.renderHeaderActions}
      >
        <footer>
          <NavLink style={{float:'right'}} to="/admin/scores">Muokkaa pisteitä</NavLink>
        </footer>
      </ContentBlock>
    );
  }
};

export default ScoreAdminBlock;


// WEBPACK FOOTER //
// ./src/modules/product/components/ScoreAdminBlock.js